'use client';
import { useGetCategories } from '@/backend/casino/get-categories';
import React, { useEffect, useState } from 'react';
import SideNavItem from '../SideNavItem/SideNavItem';
import { useCategories } from '@/store';
import { getIcon } from '@/Icons';

const language = 'EN';
const CasinoCategories = () => {
	const categories = useCategories();

	if (categories?.length === 0) {
		return null;
	}

	const formatName = (name: string) => {
		const formattedName = name.toLowerCase().split('-').join(' ');

		return formattedName;
	};

	const formatLink = (name: string) => {
		const formattedName = name.toLowerCase().split(' ').join('-');
		return `/casino/category/${formattedName}`;
	};

	return (
		<>
			{categories?.map((category, index) => {
				return (
					<SideNavItem
						key={index}
						title={formatName(category.name[language])}
						// link={`/casino/category/${category.name[language]?.toLowerCase()?.split(' ').join('-')}?category=${category.id}`}
						link={`/casino/category/${category.name[language].toLowerCase().split(' ').join('-')}`}
						icon={getIcon(category.iconKey)}
					/>
					// <SideNavItem key={index} {...category} />
				);
			})}
		</>
	);
};

export default CasinoCategories;

// {casinoData.map((item, index) => {
// 	return <SideNavItem key={index} {...item} />;
// })}
